export const COURSE_NAVIGATION_DATA_SET = 'COURSE_NAVIGATION_DATA_SET';

export const COURSE_NAVIGATION_SET_COURSE_ADMIN =
  'COURSE_NAVIGATION_SET_COURSE_ADMIN';
export const COURSE_NAVIGATION_SET_COHORT_ADMIN =
  'COURSE_NAVIGATION_SET_COHORT_ADMIN';
export const COURSE_NAVIGATION_SET_CERTIFICATION =
  'COURSE_NAVIGATION_SET_CERTIFICATION';
export const COURSE_NAVIGATION_SET_ASSESSMENT =
  'COURSE_NAVIGATION_SET_ASSESSMENT';
export const COURSE_NAVIGATION_LOAD_START = 'COURSE_NAVIGATION_LOAD_START';
export const COURSE_NAVIGATION_LOAD_FAIL = 'COURSE_NAVIGATION_LOAD_FAIL';
